import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  Camera, Shield, Lock, Users, Database, 
  School, ChevronRight, Info, Fingerprint,
  Twitter, Linkedin, Mail, Scan, Key,Instagram,
  FileKey, Terminal, Cpu, Globe, Award,
  
} from 'lucide-react';
import CreateAccountForm from './authenticate/CreateAccount';
import ForgotPasswordForm from './authenticate/ForgotPassword';
import OtpCheck from './authenticate/OtpCheck';

import PrivacyPolicy from '../../components/a1m_adm/Land/Footer/PrivacyPolicy';
import TermsOfServiceModal from '../../components/a1m_adm/Land/Footer/TermsOfService';
import SecurityModal from '../../components/a1m_adm/Land/Footer/securityTerm'; 



import theGeek from '../../assets/images/the_geek.png';
import kikawaStanley from '../../assets/images/kikawa_stanley.jpeg';
import jeffBwire from '../../assets/images/jeff_bwire.jpeg';
import muwangaIbra from '../../assets/images/muwanga_ibra.jpeg';
import kizziriLule from '../../assets/images/kizziri_lule.jpeg';
import magalaGraham from '../../assets/images/magala_graham.jpeg';
import akeraJoyce from '../../assets/images/akera_joyce.jpeg';
import laduHarry from '../../assets/images/ladu_harry.jpeg';
import oloboPatrick from '../../assets/images/olobo_patrick.jpeg';
import fatehDhillon from '../../assets/images/fateh_dhillon.jpeg';
import anaDorin from '../../assets/images/ana_dorin.jpeg';
import nassimbwaHawah from '../../assets/images/nassimbwa_hawah.jpeg';
import phillipa_babirye from '../../assets/images/phillipa_babirye.png';

// Team members data
const teamMembers = [
  {
    name: "F/N Nuru The Geek",
    role: "Chief Security Architect CSA",
    image: theGeek,
    email: "sudoroot523@gmail.com", 
    specialty: "Driving Innovation in DevOps, DevSecOps, Blockchain, AI Cybersecurity, Network Security Architecture & Zero Trust Architectures"
  },
  {
      name: "Kikawa Stanley",
      role: "Systems Security Admin",
      image: kikawaStanley,
      email: "kikaawas@yahoo.com",
      specialty: "Authentication, Authorisation & Access Management Expert (SSO/MFA/AAA)"
  },
  {
      name: "Jeff Bwire",
      role: "Legal & Data Compliance Officer",
      image: jeffBwire,
      email: "bwire177@gmail.com",
      specialty: "Secure Data Deletion & Regulatory Compliance (SDD/RC)"
  },
  {
      name: "Muwanga Ibra",
      role: "Systems Security & Admin",
      image: muwangaIbra,
      email: "ibbrahimmk@gmail.com",
      specialty: "Advanced Hashing, Cryptographic Integrity & System Hardening"
  },
  {
      name: "Kizziri Lule",
      role: "Backup & Recovery Strategist",
      image: kizziriLule,
      email: "josephelijahkatolule@gmail.com",
      specialty: "Disaster Recovery & Ransomware Mitigation"
  },
  {
      name: "Magala Graham",
      role: "Security Product Manager",
      image: magalaGraham,
      email: "magalagraham@gmail.com",
      specialty: "Firewall Product Integration & Marketing Strategy"
  },
  {
      name: "Akera Joyce",
      role: "Crypto Engineer & Tech Support",
      image: akeraJoyce,
      email: "akeraj97@gmail.com",
      specialty: "ECC, Post-Quantum Security & HelpCenter Technical Assistance"
  },
  {
      name: "Ladu Harry",
      role: "Legal & Security Risk Analyst",
      image: laduHarry,
      email: "harry12sylvester12@gmail.com",
      specialty: "Phishing Risk Assessment, Legal Compliance & Social Engineering Analysis"
  },
  {
      name: "Olobo Patrick",
      role: "Network Analysis & HelpCenter",
      image: oloboPatrick,
      email: "olobopatrick466@gmail.com",
      specialty: "Network Pattern Recognition, Threat Analysis & Advanced HelpCenter Support"
  },
  {
      name: "Fateh Dhillon",
      role: "Digital Detetive & Sec Marketing",
      image: fatehDhillon,
      email: "fddhillon99@gmail.com",
      specialty: "Mobile/Email Forensics, Threat Hunting & Security Product Marketing"
  },
  {
      name: "Ana Dorin",
      role: "Financial & Tech Integration",
      image: anaDorin,
      email: "anadorin14@gmail.com",
      specialty: "Facial Recognition for Financial Transactions & Educational Resource Management"
  },
  {
      name: "Nassimbwa Hawah",
      role: "Security Risk & Financial Analyst",
      image: nassimbwaHawah,
      email: "nassimbwahawah@gmail.com",
      specialty: "Vulnerability Scanning, Financial Risk Assessment & Security Compliance Audits"
  },
  {
    name: "Philipa Babirye",
    role: "Network Analyst & Sec Marketing",
    image: phillipa_babirye,
    email: "phillipaeve1@gmail.com",
    specialty: "Network Performance Optimization, Traffic Analysis, and Security Protocol Implementation"
},
];


  // Enhanced features list
  const features = [
    "Quantum-resistant encryption protocols",
    "AI-powered threat detection & response",
    "Zero-trust architecture implementation",
    "Real-time security monitoring & alerts",
    "Blockchain-based audit trails"
  ];
  

  

  
const FeatureScroll = () => {
  return (
    <div className="relative h-16 overflow-hidden">
      <motion.div
        animate={{ y: [0, -80] }}
        transition={{ 
          y: {
            duration: 15,
            repeat: Infinity,
            ease: "linear",
          }
        }}
      >
        {[...features, ...features].map((feature, index) => (
          <div key={index} className="h-16 flex items-center justify-center px-4">
            <span className="text-lg font-light text-teal-400 text-center">{feature}</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

const CustomSSO = ({ icon: Icon, name, color, onClick }) => (
  <motion.button
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    onClick={onClick}
    className={`w-full flex items-center justify-center space-x-3 py-2.5 px-4 rounded-lg ${color} text-white transition-all`}
  >
    <Icon size={20} />
    <span>Continue with {name}</span>
  </motion.button>
);

const TeamSection = () => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    className="max-h-80 overflow-y-auto grid grid-cols-2 gap-4 p-2 bg-gray-900/50 rounded-lg shadow-lg"
  >
    {teamMembers.map((member, index) => (
      <motion.div
        key={index}
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: index * 0.1 }}
        className="bg-gray-800/50 p-4 rounded-lg backdrop-blur-sm"
      >
        <div className="flex items-center space-x-3">
          <img 
            src={member.image} 
            alt={member.name} 
            className="w-12 h-12 rounded-full object-cover border-2 border-teal-500"
          />
          <div>
            <h3 className="font-medium text-white">{member.name}</h3>
            <p className="text-sm text-gray-400">{member.role}</p>
          </div>
        </div>
        <p className="mt-2 text-sm text-teal-400">{member.specialty}</p>
      </motion.div>
    ))}
  </motion.div>
);


const LoginInterface = () => {
  const [currentView, setCurrentView] = useState('login');
  const [showTeam, setShowTeam] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const passwordRef = useRef(null);

  const ssoLoginUrl = process.env.REACT_APP_SSO_LOGIN_URL || '';
  const boardOmeRedirectUrl = process.env.REACT_APP_BOARD_OME_REDIRECT_URL || '';

  const [privacyPolicyModalOpen, setPrivacyPolicyModalOpen] = useState(false);
    const [termsOfServiceModalOpen, setTermsOfServiceModalOpen] = useState(false);
    const [securityModalOpen, setSecurityModalOpen] = useState(false);

    // Social media links
   
     const socialLinks = [
          { 
            icon: Twitter, 
            url: "https://x.com/0X10LayerFF?t=aJ36mJOzE2ymNUd9LBpokg&s=08", 
            color: "text-blue-400 hover:text-blue-300" 
          },
          { 
            icon: Linkedin, 
            url: "https://linkedin.com/company/0x10layerff", 
            color: "text-blue-600 hover:text-blue-500" 
          },    
          { 
            icon: Instagram, 
            url: "https://www.instagram.com/0x10.layerff?igsh=dXU4NmJyMjFtdzI4&utm_source=qr", 
            color: "text-pink-500 hover:text-pink-400" 
          }
        ];


  const handleSSOClick = () => {
    if (!ssoLoginUrl || !boardOmeRedirectUrl) {
        console.error("SSO URL or Redirect URL is missing!");
        return;
    }
    
    const redirectUrl = `${ssoLoginUrl}?redirect_uri=${encodeURIComponent(boardOmeRedirectUrl)}`;
    console.log("Redirecting to:", redirectUrl); // Debugging
    window.location.href = redirectUrl;
};

  const handleLogin = async () => {
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();
  
    // Check for empty fields
    if (!trimmedEmail || !trimmedPassword) {
      setErrorMessage('Email and Password cannot be empty.');
      setError(true);
      setTimeout(() => {
        setError(false);
        setErrorMessage('');
      }, 5000);
      return;
    }
  
    setIsSubmitting(true);
  
    try {
      const response = await fetch('auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email: trimmedEmail, 
          password: trimmedPassword 
        }),
      });
  
      const data = await response.json();
      
      if (data.success) {
        //localStorage.setItem('token', data.access_token); // Store token
        //console.log(data);
        // Check if OTP is required based on the response message
        if (data.message === '2FA') {
          setCurrentView('otp'); // Change the view to the OTP input view
        } else {
          window.location.href = data.redirect_uri || '/Landing'; 
        }
      } else {
        setErrorMessage(data.error || 'Login failed. Please try again.');
        setError(true);
        setIsSubmitting(false);
        
        setTimeout(() => {
          setError(false);
          setErrorMessage('');
        }, 5000);
      }
    } catch (error) {
      setErrorMessage('An unexpected error occurred. Please try again later.');
      setError(true);
      setIsSubmitting(false);
      
      setTimeout(() => {
        setError(false);
        setErrorMessage('');
      }, 5000);
    }
  };

   // Function to go back to the login view
   const handleBackToLogin = () => {
    setCurrentView('login');
    setEmail('');
    setPassword('');
    setIsSubmitting(false);
  };


 

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col text-gray-100">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-teal-900/20 to-coral-900/20" />
        <div className="absolute inset-0">
          {[...Array(100)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-1 h-1 bg-teal-500/20 rounded-full"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
              }}
              animate={{
                scale: [1, 1.5, 1],
                opacity: [0.2, 0.5, 0.2],
              }}
              transition={{
                duration: 2 + Math.random() * 2,
                repeat: Infinity,
                delay: Math.random() * 2,
              }}
            />
          ))}
        </div>
      </div>

      {/* Header */}
      <motion.nav
        className="fixed top-0 left-0 right-0 bg-gray-800/80 backdrop-blur-sm z-10 border-b border-white/10"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
      >
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <motion.div
              className="flex items-center space-x-3"
              whileHover={{ scale: 1.02 }}
            >
              <motion.div
                className="h-10 w-10 rounded-xl flex items-center justify-center bg-gradient-to-br from-teal-600 to-coral-600"
                animate={{
                  boxShadow: [
                    '0 0 20px rgb(0 128 128 / 0.2)', // Teal
                    '0 0 40px rgb(255 127 80 / 0.4)', // Coral
                    '0 0 20px rgb(0 128 128 / 0.2)',
                  ],
                }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                <Shield className="text-white" size={24} />
              </motion.div>
              <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-teal-400 to-coral-400">
                0x10LayerFF
              </span>
            </motion.div>

            <div className="flex space-x-6">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShowTeam(!showTeam)}
                className="flex items-center text-gray-300 hover:text-white transition-colors"
              >
                <Users className="h-5 w-5" />
                <span className="ml-2">Team</span>
              </motion.button>
              
            </div>
          </div>
        </div>
      </motion.nav>

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center p-4 pt-20">
        <div className="w-full max-w-5xl flex flex-col lg:flex-row rounded-2xl overflow-hidden backdrop-blur-sm bg-white/5 border border-white/10">
          {/* Left Side - Info Panel */}
          <motion.div 
            className="lg:w-1/2 p-8"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
          >
            <div className="flex items-center space-x-4 mb-8">
              <motion.div
                className="h-16 w-16 rounded-2xl bg-gradient-to-br from-teal-600 to-coral-600 flex items-center justify-center"
                animate={{
                  boxShadow: [
                    '0 0 20px rgb(0 128 128 / 0.2)',
                    '0 0 40px rgb(255 127 80 / 0.4)',
                    '0 0 20px rgb(0 128 128 / 0.2)',
                  ],
                }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                <Shield className="text-white h-8 w-8" />
              </motion.div>
              <div>
                <h2 className="text-2xl font-bold text-white">0x10LayerFF</h2>
                <p className="text-gray-400">Advanced Security Platform</p>
              </div>
            </div>

            <FeatureScroll />

            {showTeam ? (
              <TeamSection />
            ) : (
              <div className="grid grid-cols-2 gap-4 mt-8">
                {[
                  { icon: FileKey, text: "Zero Trust Security" },
                  { icon: Terminal, text: "Advanced Analytics" },
                  { icon: Cpu, text: "AI Protection" },
                  { icon: Globe, text: "Global Coverage" }
                ].map(({ icon: Icon, text }, index) => (
                  <motion.div
                    key={index}
                    className="bg-gray-800/50 p-4 rounded-lg backdrop-blur-sm"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <Icon className="h-6 w-6 text-teal-400 mb-2" />
                    <span className="text-sm text-gray-300">{text}</span>
                  </motion.div>
                ))}
              </div>
            )}
          </motion.div>

          {/* Right Side - Login Form */}
          
          <motion.div 
            className="lg:w-1/2 p-8 bg-gray-800/50"
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={currentView}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                className="space-y-6"
              >
                {/* Conditional rendering based on currentView */}
              {currentView === 'login' && (
                <>
                  <div className="text-center mb-6">
                    <h2 className="text-2xl font-bold text-white">Welcome Back</h2>
                    <p className="text-gray-400">Access your secure workspace</p>
                  </div>

                  <div className="space-y-4">
                    <CustomSSO 
                      icon={Key} 
                      name="0x10SSO" 
                      color="bg-gradient-to-r from-teal-600 to-coral-600"
                      onClick={handleSSOClick}
                    />
                    
                    <div className="relative">
                      <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-gray-700"></div>
                      </div>
                      <div className="relative flex justify-center text-sm">
                        <span className="px-2 bg-gray-800/50 text-gray-400">Or continue with</span>
                      </div>
                    </div>

                    <input 
                      type="email" 
                      className="w-full px-4 py-2.5 bg-gray-900/50 border border-gray-700 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          passwordRef.current?.focus();  // move focus to password
                        }
                      }}
                    />

                    <input 
                      type="password" 
                      ref={passwordRef}
                      className="w-full px-4 py-2.5 bg-gray-900/50 border border-gray-700 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleLogin(); // trigger login on Enter
                        }
                      }}
                    />
                    
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      className="w-full py-2.5 bg-gradient-to-r from-teal-600 to-coral-600 text-white rounded-lg transition-all flex items-center justify-center space-x-2"
                      onClick={handleLogin}
                      disabled={isSubmitting}
                    >
                      <Lock size={18} />
                      <span>{isSubmitting ? 'Logging in...' : 'Sign In Securely'}</span>
                    </motion.button>

                    
                    {error && (
                      <div
                        className="error-message"
                        style={{
                          color: 'red',
                          textAlign: 'center', // Center the text
                          width: '100%', // Full width to align horizontally in the container
                          margin: '10px 0', // Optional: Add some margin for spacing
                        }}
                      >
                        {errorMessage}
                      </div>
                    )}
                  </div>

                  <div className="flex justify-between text-sm">
                    <button 
                      className="text-teal-400 hover:text-teal-300" 
                      onClick={() => setCurrentView('forgot')}
                    >
                      Forgot password?
                    </button>
                    <button 
                      className="text-teal-400 hover:text-teal-300" 
                      onClick={() => setCurrentView('create-account')}
                    >
                      Create account
                    </button>
                  </div>
                </>
              )}

              {currentView === 'forgot' && <ForgotPasswordForm onBack={handleBackToLogin} />}
              {currentView === 'create-account' && <CreateAccountForm onBack={handleBackToLogin} />}
              {currentView === 'otp' && <OtpCheck onBack={handleBackToLogin}/>}
            </motion.div>
            </AnimatePresence>
          </motion.div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 border-t border-white/10 py-6 bg-gray-800/80 backdrop-blur-sm">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex justify-between items-center">
                        <div className="flex space-x-4">
                            <a
                                href="#"
                                onClick={() => setPrivacyPolicyModalOpen(true)}
                                className="text-sm text-gray-400 hover:text-white transition-colors"
                            >
                                Privacy
                            </a>
                            <a
                                href="#"
                                onClick={() => setTermsOfServiceModalOpen(true)}
                                className="text-sm text-gray-400 hover:text-white transition-colors"
                            >
                                Terms
                            </a>
                            <a
                                href="#"
                                onClick={() => setSecurityModalOpen(true)}
                                className="text-sm text-gray-400 hover:text-white transition-colors"
                            >
                                Security
                            </a>
                        </div>
                        <div className="flex space-x-4">
                            {socialLinks.map((item, index) => (
                                <a 
                                    key={index} 
                                    href={item.url} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    <motion.button
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                        className="p-2 rounded-lg hover:bg-gray-700/50 transition-colors"
                                    >
                                        <item.icon className="h-5 text-teal-400" />
                                    </motion.button>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </footer>

            {/* Modals */}
            <PrivacyPolicy
                privacyPolicyModalOpen={privacyPolicyModalOpen}
                setPrivacyPolicyModalOpen={setPrivacyPolicyModalOpen}
            />
            <TermsOfServiceModal
                termsOfServiceModalOpen={termsOfServiceModalOpen}
                setTermsOfServiceModalOpen={setTermsOfServiceModalOpen}
            />
            <SecurityModal
                securityModalOpen={securityModalOpen}
                setSecurityModalOpen={setSecurityModalOpen}
            />  
    </div>
  );
};

export default LoginInterface;
